const RELOAD_FLAG_PREFIX = 'serme:dyn-import-reload:';
const RELOAD_TTL_MS = 60_000;
// Chunk introuvable apres un deploiement : Chrome, Firefox, Safari, puis CSS du chunk (Vite).
const CHUNK_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/;

function shouldRetry(key: string): boolean {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return true;
    const ts = Number.parseInt(raw, 10);
    if (!Number.isFinite(ts)) return true;
    return Date.now() - ts > RELOAD_TTL_MS;
  } catch {
    return true;
  }
}

function markRetry(key: string): void {
  try {
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // sessionStorage indisponible : on laisse le reload tenter sa chance
  }
}

export async function loadDynamic<T>(factory: () => Promise<T>): Promise<T> {
  try {
    return await factory();
  } catch (err) {
    const msg = err instanceof Error ? err.message : String(err);
    if (!CHUNK_ERROR.test(msg)) {
      throw err;
    }
    const key = `${RELOAD_FLAG_PREFIX}${msg}`;
    if (!shouldRetry(key)) {
      throw err;
    }
    markRetry(key);
    window.location.reload();
    return new Promise<T>(() => {});
  }
}
